import React, { useState, useContext, useEffect } from 'react';
import { TableDataContext } from '../index';
import { Camelcase, escapeCsv, origin } from '../../../JS/Common';
import { UserContext } from '../../../App';
import { useSelector } from 'react-redux';

export default function SupportTicketTable() {
    const StateData = useSelector((state) => state.authData);
    const { AllDashBoardData } = useContext(TableDataContext);
    const [ticketStatus, setTicketStatus] = useState('open');
    const [loadData, setLoadData] = useState({ technologyTickets: [], maintenanceTickets: [], show: false });
    const { UserData } = useContext(UserContext);

    useEffect(() => {
        const updateLoadData = (tickets, type) => {
            const data = tickets?.length > 20 ? tickets?.slice(0, 20) : tickets;
            setLoadData(prevState => ({
                ...prevState,
                [type]: data
            }));
        };

        if (AllDashBoardData?.SupportTickets?.data?.technology_tickets?.length > 0) {
            updateLoadData(AllDashBoardData.SupportTickets.data.technology_tickets, 'technologyTickets');
        } else {
            updateLoadData([], 'technologyTickets');
        }

        if (AllDashBoardData?.SupportTickets?.data?.maintenance_tickets?.length > 0) {
            updateLoadData(AllDashBoardData.SupportTickets.data.maintenance_tickets, 'maintenanceTickets');
        } else {
            updateLoadData([], 'maintenanceTickets');
        }
    }, [AllDashBoardData]);

    const loadMoreTickets = () => {
        const updateTickets = (currentTickets, allTickets) => {
            const newTickets = currentTickets.concat(
                allTickets?.slice(currentTickets.length, currentTickets.length + 20)
            );
            return newTickets.length === allTickets.length ? allTickets?.slice(0, 20) : newTickets;
        };

        if (ticketStatus === 'open') {
            const newTechnologyTickets = updateTickets(loadData.technologyTickets, AllDashBoardData.SupportTickets.data.technology_tickets);
            setLoadData(prevState => ({ ...prevState, technologyTickets: newTechnologyTickets }));
        } else {
            const newMaintenanceTickets = updateTickets(loadData.maintenanceTickets, AllDashBoardData.SupportTickets.data.maintenance_tickets);
            setLoadData(prevState => ({ ...prevState, maintenanceTickets: newMaintenanceTickets }));
        }
    };

    const generateUrl = (ticketNum, hdId, tickeetid) => {
        const schoolnumber = StateData?.Schoolnumber;
        const path = hdId ? `/helpdesk-ticket/${hdId}/${schoolnumber}/${ticketNum}` : `/ticket/${tickeetid}/${schoolnumber}/${ticketNum}`;
        const url = `${origin}${path}`;
        const newTab = window.open('', '_blank');
        newTab.location.href = url;
        newTab.focus();
    };

    const renderTickets = (tickets) => (
        tickets.length > 0 ? tickets.map((item, i) => (
            <tr className='OddEvenClass tableBorderHide py-3' key={item.id}>
                <td className="py-12">{item.title}</td>
                <td className="py-12">{item.name}</td>
                <td className="py-12">
                    {item.assigned_to ?
                        item.user ?
                            <div className="location-name">{item.user ? Camelcase(item.user.first_name) + ' ' + Camelcase(item.user.last_name) : '-'}</div> :
                            <div className="location-name">{item.user_group ? item.user_group.name : '-'}</div> :
                        <div className="location-name">-</div>
                    }
                </td>
                <td className="text-center">
                    <img src="/images/previewpdficon.svg" className="cursor-pointer px-1" title={`${UserData.helpdeskUpdatedFlag ? 'Preview Help Desk Tickets' : 'Preview Support Tickets'}`} onClick={() => generateUrl(UserData.helpdeskUpdatedFlag != null ? item.request_num : item.support_ticket_num, UserData.helpdeskUpdatedFlag != null ? item.id : null, item.id)} height='20px' />
                </td>
            </tr>
        )) : (
            <tr className='OddEvenClass tableBorderHide py-3'>
                <td colSpan={4} className='text-center'>No Record Found</td>
            </tr>
        )
    );
    const data = [
        {
            title: 'Technology Open Tickets',
            tickets: loadData?.technologyTickets,
        },
        {
            title: 'Maintenance Open Tickets',
            tickets: loadData?.maintenanceTickets,
        },
    ];
    const downloadCSV = () => {
        let csvContent = '';

        data.forEach((group) => {
            csvContent += `${group.title}\n`;
            csvContent += `Ticket Number,Subject,Name,Email,Description\n`;
            group.tickets.forEach((ticket) => {
                csvContent += `${UserData.helpdeskUpdatedFlag != null ? ticket.request_num : ticket.support_ticket_num},${escapeCsv(ticket.title)},${escapeCsv(ticket.name)},${ticket.email || ''},${escapeCsv(ticket.description) || '-'}\n`;
            });
            csvContent += `\n`; // blank line between groups
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = 'tickets_report.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <React.Fragment>
            <div className="col-12 greyBoxShadow" style={{ height: "100%" }}>
                <div className="w-100">
                    <div className="row mt-2 px-2 time">
                        <div className='col-md-8 Header'>
                            <b className='font-15'>{UserData.helpdeskUpdatedFlag != null ? 'Help Desk Open Tickets' : 'Support Open Tickets'}</b><br />
                        </div>
                        <div className='col-md-4 text-end'>
                            <b className='cursor-pointer text-decoration-underline' onClick={downloadCSV}>Download CSV</b>
                        </div>
                    </div>
                    <hr className="my-2" />
                    <div className="px-3">
                        <div className="row py-2">
                            <div className="col-6">
                                <input className="form-check-input me-1" value="open" type="radio" name='SupportTicket' checked={ticketStatus === "open"} onChange={(e) => setTicketStatus(e.target.value)} />
                                <label className="form-check-label font-13 fw-bolder">Technology</label>
                            </div>
                            <div className="col-6">
                                <input className="form-check-input me-1" value="close" type="radio" name='SupportTicket' checked={ticketStatus === "close"} onChange={(e) => setTicketStatus(e.target.value)} />
                                <label className="form-check-label font-13 fw-bolder">Maintenance</label>
                            </div>
                        </div>
                    </div>
                    <hr className="my-2" />
                    {AllDashBoardData?.SupportTickets?.loader ? (
                        <div className='row'>
                            <div className="col-12 text-center pt-2">
                                <img src="/images/loder.svg" style={{ width: "30px" }} alt="Loading..." />
                            </div>
                        </div>
                    ) : (
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" className='fw-600 font-14'>Subject</th>
                                    <th scope="col" className='fw-600 font-14'>Name</th>
                                    <th scope="col" className='fw-600 font-14'>Assigned</th>
                                    <th scope="col" className='fw-600 font-14 text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ticketStatus === "open" ? renderTickets(loadData.technologyTickets) : renderTickets(loadData.maintenanceTickets)}
                            </tbody>
                        </table>
                    )}
                </div>
                {ticketStatus === "open" && AllDashBoardData?.SupportTickets?.data?.technologyTickets?.length > 20 && (
                    <div className="col-12 p-2 admin-table-border-top">
                        <span style={{ textDecoration: "underline", cursor: "pointer", color: "var(--primary-color)" }} onClick={loadMoreTickets}>
                            {loadData.technologyTickets.length === AllDashBoardData.SupportTickets.data.technologyTickets.length ? "Hide" : "Load More"}
                        </span>
                    </div>
                )}
                {ticketStatus === "close" && AllDashBoardData?.SupportTickets?.data?.maintenanceTickets?.length > 20 && (
                    <div className="col-12 p-2 admin-table-border-top">
                        <span style={{ textDecoration: "underline", cursor: "pointer", color: "var(--primary-color)" }} onClick={loadMoreTickets}>
                            {loadData.maintenanceTickets.length === AllDashBoardData.SupportTickets.data.maintenanceTickets.length ? "Hide" : "Load More"}
                        </span>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}
